<template>
  <div class="header">
    <div class="header-title">
      <div class="header_tit" @click="top" title="点击返回顶部 ↑">
        <img class="header_logo" src="../../assets/img/home/linghang.png" alt />
      </div>
    </div>
    <div class="header_tab">
      <div class="hd_tab">
        <span style="margin-right: 20px;">欢迎您：{{ entName }}</span>
        <span>您上次登录的时间：{{ realTime }}</span>
      </div>
      <div class="hd_right">
        <div class="hd_user">
          <el-dropdown>
            <span class="el_link">
              <img src="../../assets/img/home/admin.png" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <span @click="changPassword">修改密码</span>
              </el-dropdown-item>
              <el-dropdown-item>

                <span @click="clickMe">帮助中心</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span @click="loginOut">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="username">{{ username }}</span>
        </div>
      </div>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="400px">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="原密码:">
          <el-input v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item label="新密码:">
          <el-input v-model="form.newpassword"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:">
          <el-input v-model="form.newspassword"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button>取 消</el-button>
        <el-button type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import bus from "./bus";
import GlobalUtil from "@/utils/globalUtil";
import Breadcrumb from "./breadCrumb";

export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      username: "",
      name: "",
      realTime: "",
      subRouter: "",
      collapse: true,
      fullscreen: false,
      // name: '3D',
      activeFty: {},

      message: 2,
      userInfo: GlobalUtil.getLocalStorage("userInfo"),
      // avatar: 'http://up.qqya.com/allimg/201710-t/17-101805_137721.jpg',
      weatherInfo: {},
      dialogVisible: false,
      form: {
        password: "",
        newpassword: "",
        newspassword: ""
      },
      entName: "" //企业名称
    };
  },
  computed: {
    avatar() {
      return "http://up.qqya.com/allimg/201710-t/17-101805_137721.jpg";
    },
    userType() {
      let userInfo = GlobalUtil.getSessionStorage("userInfo");
      return userInfo.job;
    },
    num() {
      return this.$store.state.num;
    }
  },
  created() {
    this.subRouter = this.$route.path.split("/")[1];
    (this.realTime =
      GlobalUtil.readCookie("lastLoginDate") || "无上次登录时间"),
      // this.getTianQi();
      (this.username = GlobalUtil.readCookie("username1"));
  },
  destroyed() { },
  methods: {
    // 获取企业名称
    getWebInfoAll() {
      let entCode = localStorage.getItem('entCode');
      this.$axios.get(this.$url.getWebInfo, { entCode: entCode })
        .then(res => {
          this.entName = res.data.entName;
          localStorage.setItem('offDistribution', res.data.offDistribution);
        });
    },
    clickMe() {
      // let routeData = this.$router.resolve({ name: 'personnelDetails', query: { id: id} });
      window.open('https://www.yuque.com/books/share/5450ff03-d28f-449c-a396-5899af721935?#', '_blank');
    },
    goPath(name) {
      console.log(name);
      // this.$router.push({name: 'campusLibrary'})
      // console.log(this.$route)
      this.subRouter = name;
      this.$router.push({
        name: name
      });
    },
    top() {
      // 点击后内页返回顶部
      // console.log(this.$refs)
      this.$emit("backTop", "jjjjj");
    },
    add() {
      this.$store.commit("addNum");
    },
    // 修改秘密
    changPassword() {
      this.$router.push("/home/accountindex");
    },
    // 退出登录
    loginOut() {
      // GlobalUtil.clearAllCookie();
      // GlobalUtil.removeSessionStorage();
      GlobalUtil.delCookie("username");
      GlobalUtil.delCookie("headers");
      GlobalUtil.delCookie("entCodeEq");
      GlobalUtil.delCookie("lastLoginDate");
      GlobalUtil.delCookie("username");
      // if(!GlobalUtil.readCookie('isChoose')){

      // }
      this.$router.push("/login");
    },
    // 侧边栏折叠
    collapseChage() {
      this.collapse = !this.collapse;
      bus.$emit("collapse", this.collapse);
    },
    // 全屏事件
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    }
  },
  mounted() {
    this.getWebInfoAll()
  }
};
</script>
<style scoped>
.username {
  position: relative;
  top: -7px;
}

.header {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  height: 64px;
  background: rgba(255, 255, 255, 1);
  top: 0;
  left: 0;
  position: fixed;
}

.avatar_img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  float: right;
  margin-top: 10px;
  margin-right: 10px;
}

.collapse_btn {
  font-size: 22px;
  padding: 0 21px;
  cursor: pointer;
  line-height: 64px;
}

.hd_tab {
  display: flex;
  max-width: 1200px;
  min-width: 1000px;
  line-height: 64px;
  padding-left: 30px;
}

.header_tit {
  width: 256px;
  text-indent: 1.5em;
  line-height: 64px;
  font-size: 16px;
  cursor: pointer;
  background: #ffffff;
  color: #333;
  display: flex;
  align-items: center;
  justify-items: center;
}
</style>
<style>
.header_tit .el-dropdown {
  font-size: 20px;
  font-family: AlibabaPuHuiTiM;
  color: rgba(255, 255, 255, 1);
}

.header[data-v-3288e5bb] .el-dropdown {
  height: 0;
  width: 0;
}

.header .el-dropdown {
  color: #333;
  margin-right: 10px;
  float: left;
  height: 30px !important;
  width: 30px !important;
  margin-top: 10px;
}
</style>
<style lang="less" scoped>
.header {
  ::v-deep.el-dropdown {
    height: 30px !important;
  }
}

.header_tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

// .header_logo {
//   width: auto;
//   height: 100%;
// }

.hd_user {
  color: #333;
  line-height: 64px;
  padding-right: 20px;
}

.header-title {
  height: 100%;
  display: flex;
  align-items: center;

  img {
    width: auto;
    height: 50px;
  }
}

.helpCenter {
  color: #606266;
}

::v-deep.el-dropdown-item:hover {
  // .helpCenter {
  color: #7ad6e7 !important;
  // }
}
</style>
